import React, { useState } from 'react';
import VerificationInput from 'react-verification-input';

import Button from 'components/shared/Button/Button';

const COPY = {
  gauth: {
    title: 'Two-factor authentication',
    subtitle: 'Enter the 6-digit code from your authenticator app.'
  },
  sms: {
    title: 'Verification code sent',
    subtitle: 'Enter the 6-digit code we just sent to your phone.'
  },
  email: {
    title: 'Verification code sent',
    subtitle: 'Enter the 6-digit code we just sent to your email.'
  }
};

const MISCONFIGURED_COPY = {
  title: 'Account needs additional setup',
  subtitle:
    'This account requires multi-factor authentication but no factor is set up. Please contact support.'
};

const MfaChallengeForm = ({ kind, loading, error, onSubmit, onFallbackToSms }) => {
  const [code, setCode] = useState('');

  // Account stuck in a state where MFA is required but no factor exists.
  // Surfaces the inconsistency loudly instead of looping on a code input.
  if (!kind) {
    return (
      <div className="flex flex-col gap-2 rounded-lg border border-solid border-warning-200 bg-warning-50 p-4 text-sm">
        <p className="font-semibold text-warning-700">{MISCONFIGURED_COPY.title}</p>
        <p className="text-warning-600">{MISCONFIGURED_COPY.subtitle}</p>
      </div>
    );
  }

  const copy = COPY[kind] || COPY.sms;

  const handleSubmit = () => {
    if (code.length === 6) onSubmit(code);
  };

  return (
    <div className="flex flex-col justify-center align-middle">
      <div className="mb-4 text-center">
        <p className="text-base font-500 text-neutral-900">{copy.title}</p>
        <p className="mt-1 text-sm text-neutral-600">{copy.subtitle}</p>
      </div>

      <VerificationInput
        validChars="0-9"
        value={code}
        onChange={setCode}
        onComplete={onSubmit}
        inputProps={{ autoComplete: 'one-time-code' }}
        placeholder=""
        classNames={{
          character: '!rounded-lg border-none text-primary-600 aspect-square bg-white shadow',
          characterSelected:
            '!rounded-lg border-none text-primary-600 aspect-square bg-primary-100 shadow border-b-2 border-b-solid border-b-primary-500',
          characterInactive:
            '!rounded-lg border-none text-primary-600 aspect-square bg-white shadow'
        }}
      />

      {error && <p className="mt-3 text-center text-sm text-danger-600">{error}</p>}

      <Button
        text="Verify"
        onClick={handleSubmit}
        isLoading={loading}
        isDisabled={code.length !== 6}
        className="mt-10 w-full"
      />

      {kind === 'gauth' && onFallbackToSms && (
        <button
          type="button"
          onClick={onFallbackToSms}
          className="mt-3 text-sm text-primary-600 hover:text-primary-700 hover:underline">
          Use a text message code instead
        </button>
      )}
    </div>
  );
};

export default MfaChallengeForm;
